import React, { useEffect, useState } from "react";

//custom
import moment from "moment";
import DatePicker from "react-datepicker";
//import axios
import axios from "axios";

//utils
import {
  check_authorized,
  signoutuser_confirm,
  isloginuser,
  get_userseckey,
  getuniquedeviceid,
  signoutuser,
} from "../../utils/Helper/CheckAuth";
import CallURL from "../../utils/API/CallURL";
import {
  showLoading,
  stopLoading,
  sent_clean_var,
} from "../../utils/Helper/JSHelper";

function UserCard(props) {
  //props
  const { item_info } = props;

  //const variable
  const [usrid, set_usrid] = useState(item_info.usrid);
  const [fullname, set_fullname] = useState(item_info.fullname);
  const [mobile, set_mobile] = useState(item_info.mobile);
  const [accvalidtill, set_accvalidtill] = useState(item_info.accvalidtill);
  const [lastaccess, set_lastaccess] = useState(item_info.lastaccess);
  const [accsts, set_accsts] = useState(item_info.accsts);
  const [acctype, set_acctype] = useState(item_info.acctype);

  //extra variable
  const [current_date, set_current_date] = useState(
    new Date().toLocaleString("en-US", {
      timeZone: "Asia/Calcutta",
    })
  );
  const [current_date_int, set_current_date_int] = useState(
    Date.parse(current_date)
  );
  const [todaydate, set_todaydate] = useState(
    moment(current_date_int).format("YYYY-MM-DD")
  );
  const [isSameOrAfterDate, set_isSameOrAfterDate] = useState(
    accvalidtill != null ? moment(accvalidtill).isSameOrAfter(todaydate) : false
  );
  const [validity_date, set_validity_date] = useState(
    accvalidtill == null ? null : new Date(accvalidtill)
  );

  //action on user card
  //change_status
  function change_status(status) {
    //showLoading
    showLoading();
    // Create an object of formData
    const formData = new Object();
    // Update the formData object
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    //extra variable
    formData.usrid = usrid;
    formData.status = status;
    // Send formData object
    axios
      .post(CallURL.edit_acc_status, formData)
      .then((response) => {
        //stopLoading
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "unauthorized") {
          //make logout
          signoutuser();
        } else if (response.data.apires == "success") {
          set_accsts(status);
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        //stopLoading
        stopLoading();
        console.log(error);
        alert("Something went wrong. Try again.");
      });
  }
  //reset_devices
  function reset_devices() {
    //showLoading
    showLoading();
    // Create an object of formData
    const formData = new Object();
    // Update the formData object
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    //extra variable
    formData.usrid = usrid;
    // Send formData object
    axios
      .post(CallURL.edit_acc_device, formData)
      .then((response) => {
        //stopLoading
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "unauthorized") {
          //make logout
          signoutuser();
        } else if (response.data.apires == "success") {
          alert("Login device data reset.");
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        //stopLoading
        stopLoading();
        console.log(error);
        alert("Something went wrong. Try again.");
      });
  }
  //change_validity
  function change_validity(date) {
    /*alert(
      accvalidtill + " : " + moment(date, "DD MMMM YYY").format("YYYY-MM-DD")
    );
    set_accvalidtill(moment(date, "DD MMMM YYY").format("YYYY-MM-DD"));*/
    //showLoading
    showLoading();
    // Create an object of formData
    const formData = new Object();
    // Update the formData object
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    //extra variable
    formData.usrid = usrid;
    formData.date =
      date != null ? moment(date, "DD MMMM YYY").format("YYYY-MM-DD") : null;
    // Send formData object
    axios
      .post(CallURL.edit_acc_validity, formData)
      .then((response) => {
        //stopLoading
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "unauthorized") {
          //make logout
          signoutuser();
        } else if (response.data.apires == "success") {
          var temp_accvalidtill =
            date != null
              ? moment(date, "DD MMMM YYY").format("YYYY-MM-DD")
              : null;
          set_isSameOrAfterDate(
            temp_accvalidtill != null
              ? moment(temp_accvalidtill).isSameOrAfter(todaydate)
              : false
          );
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        //stopLoading
        stopLoading();
        console.log(error);
        alert("Something went wrong. Try again.");
      });
  }

  return (
    <>
      <div className="row">
        <div className="col s2">
          <font
            className="font_sub_small_content"
            style={{ color: isSameOrAfterDate ? "green" : "red" }}
          >
            <i className="fa fa-calendar fa-lg" />
          </font>
        </div>
        <div className="col s10">
          <DatePicker
            dateFormat="dd MMMM yyyy"
            selected={validity_date}
            onChange={(date) => {
              set_validity_date(date);
              change_validity(date);
            }}
            style={{ fontSize: "50px" }}
          />
        </div>
        {(() => {
          if (!isSameOrAfterDate) {
            return (
              <div className="col s12">
                <font
                  className="font_sub_small_content_18"
                  style={{ color: "red" }}
                >
                  Validity Expired
                </font>
              </div>
            );
          }
        })()}
      </div>
      <font className="font_sub_small_content_18">
        #ID {usrid} @ {acctype}
      </font>
      <br />
      <font className="font_sub_small_content">
        <i className="fa fa-user fa-lg" />
        {" " + fullname}
      </font>
      <br />
      <font className="font_sub_small_content">
        <i className="fa fa-phone fa-lg" />
        {" " + mobile}
      </font>
      <br />
      {(() => {
        const return_text = [];
        if (accsts == "1") {
          return_text.push(
            <font className="font_sub_small_content" style={{ color: "green" }}>
              <i className="fa fa-check fa-lg" /> Active Account{" "}
              <a
                className="btn-floating z-depth-1 red"
                onClick={() => change_status("0")}
                style={{ zIndex: "0" }}
              >
                <i className="fa fa-close"></i>
              </a>
            </font>
          );
        }
        if (accsts == "0") {
          return_text.push(
            <font className="font_sub_small_content" style={{ color: "red" }}>
              <i className="fa fa-close fa-lg" /> Deactivated Account{" "}
              <a
                className="btn-floating z-depth-1 green"
                onClick={() => change_status("1")}
                style={{ zIndex: "0" }}
              >
                <i className="fa fa-check"></i>
              </a>
            </font>
          );
        }
        return return_text;
      })()}
      <br />
      <font className="font_sub_small_content" style={{ color: "blue" }}>
        <i className="fa fa-sign-out fa-lg" /> Reset Login Devices{" "}
        <a
          className="btn-floating z-depth-1 blue"
          onClick={() => reset_devices()}
          style={{ zIndex: "0" }}
        >
          <i className="fa fa-refresh"></i>
        </a>
      </font>
      <br />
      <font className="font_sub_small_content_18 right">
        <i className="fa fa-circle fa-lg online_circle" />
        {" " + moment(lastaccess).format("DD MMM YYYY hh:mm a")}
      </font>
      <br />
    </>
  );
}

export default UserCard;
